import React from 'react'
import LabeledValue from '../../../components/common/LabeledValue'
import { StatusField } from '../../../utils/statusFieldsUtils'

interface StatusFieldsListProps {
  fields: StatusField[]
}

/**
 * Renders the labeled fields produced by `getCurrentStatusFields`, shared by the
 * approver current-status summary, request history, and status-specific views.
 * @param fields - Ordered list of labeled fields to render.
 * @returns The rendered fields, skipping empty ones except comment fields.
 */
const StatusFieldsList: React.FC<StatusFieldsListProps> = ({ fields }) => (
  <div className="[&>p]:mb-1! [&>p:last-child]:mb-0!">
    {fields.map((field) => {
      const shouldRender =
        (field.value !== undefined && field.value !== null) ||
        field.label === 'Approver Comments' ||
        field.label === 'Employee Comments' ||
        field.label === 'Employee Comments Regarding Retraction' ||
        field.label === 'Approver Requested Retraction'

      if (!shouldRender) {
        return null
      }

      if (field.label === 'Approver Requested Retraction') {
        return (
          <p key={field.label} className="p3 -medium m-0 py-0 leading-normal">
            <strong>{field.value || ''}</strong>
          </p>
        )
      }
    if (field.label === 'Original Time Off Request ID' ||field.label === 'Partial Retraction Reference ID') {
   return (
     <p key={field.label} className="p3 -medium m-0 py-0 leading-normal">
       <span>{field.label}: </span>
       <a
        href={`/approver/process/${field.value}`}
        className="text-primary underline"
       >
        {field.value}
      </a>
    </p>
   )
  }
      return <LabeledValue key={field.label} label={field.label} value={field.value || ''} />
    })}
  </div>
)

export default StatusFieldsList
